import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reduceSendPaymentLinkDto } from '../../actions/payment/reduceSendPaymentLinkDto';
import { selectPaymentEmail } from '../../selectors/payment/selectPaymentEmail';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* sendPaymentLinkSaga() {
    try {
        yield put(reduceLoading({ code: 'sendPaymentLink', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());
        const paymentEmail = yield select(selectPaymentEmail());

        const response = yield call(fetch, '/api/payment/sendpaymentlink', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                policyTransactionGuid: entity,
                emailAddress: paymentEmail,
            }),
        });

        const result = yield call([response, 'json']);

        yield put(reduceSendPaymentLinkDto(result));
        yield put(reduceOperation(result.operation));
    } catch (error) {
        console.log('Error while calling Payment Link API - ', error);
        yield put(reduceSendPaymentLinkDto(null));
        yield put(
            reduceOperation({
                status: false,
            }),
        );
    } finally {
        yield put(reduceLoading({ code: 'sendPaymentLink', value: false }));
    }
}
